






































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';

import { IBankAttribute } from '../../models';
import { BaseDetail } from '../Base/BaseDetail';

const namespace = 'bankAttribute';
const ns = { namespace };

@Component
export default class ProposalStatusDetail extends BaseDetail<IBankAttribute> {
  namespace = namespace;
  @State('entities', ns) entities: Record<string, IBankAttribute>;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  mounted() {
    this.loadEntity();
  }
}
